import React from "react"
const My404Page = () =>{
    return (
        <h1>Page Not Found</h1>
    )
}
export default My404Page